import store from '@/store'
import * as api from '@/network/api'
import * as Network from '@/helpers/network.js'
export function getAccount() {
    return new Promise((resolve, reject) => {
        Network.getDataWidthRetry(`v1/accounts`)
            .then(({ data }) => {
                resolve(data)
            })
            .catch(error => {
                reject(error)
            })
    })
}
export function editAccount(data) {
    return new Promise((resolve, reject) => {
        api.patch(Network.provideURL(`v1/accounts`), data)
            .then(({ data }) => {
                resolve(data)
            })
            .catch(error => {
                reject(error)
            })
    })
}
export function getBoughtItems() {
    return Network.getDataWidthRetry(`v1/marketplace/items`)
        .then(({ data }) => {
            store.commit('setBoughtItems', data)
            store.dispatch('source/checkBoughtItems')
        })
        .catch(error => {
            return error
        })
}
export function getStorage() {
    return api
        .get('v1/storage')
        .then(({ data }) => {
            store.commit('setRoleStorage', data)
            return data
        })
        .catch(error => {
            return error
        })
}
